import { render, staticRenderFns } from "./productFileManagement.vue?vue&type=template&id=0ac85c9c&scoped=true&"
import script from "./productFileManagement.vue?vue&type=script&lang=js&"
export * from "./productFileManagement.vue?vue&type=script&lang=js&"
import style0 from "./productFileManagement.vue?vue&type=style&index=0&id=0ac85c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac85c9c",
  null
  
)

export default component.exports